import type { API } from 'chessboard/api/config/types';
import type { Game } from 'chessboard/model/game/types';
import { getExtendedNode } from 'chessboard/model/game/get-extended-node';
import { isFirstNodeInLine } from 'model/move/is-first-node-in-line';

/**
 * Create the getSelectedNode method.
 */
export function createGetSelectedNode(context: API.Context) {
  /**
   * Gets the currently selected node. Return null if one doesn't exist.
   */
  return function getSelectedNode(): Game.Move.Node | null {
    const { api, game } = context;

    const ids = game.ids();

    if (isFirstNodeInLine(ids.move)) {
      return null;
    }

    const line = api.getRawLines()[ids.line];

    return getExtendedNode({
      move: line[ids.move],
      startingMoveNumber: game.startingMoveNumber(),
    });
  };
}
